<script>
import {POINT_MARKER_ICON_CONFIG} from "../../constants/mapSettings";

export default {
	props: {
		google: {
			type: Object,
			required: true
		},
		map: {
			type: Object,
			required: true
		},
		marker: {
			// type: Object,
			// required: true,
			default: function () {
				return {
					position: {lat: 25.774, lng: -80.190}
				};
			}
		}
	},

	created() {
		const {Marker} = this.google.maps;
		console.log(Marker);

		new Marker({
			position: this.marker.position,
			marker: this.marker,
			map: this.map,
			icon: POINT_MARKER_ICON_CONFIG,
		});
	},

	render() {
	}
};
</script>
